(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["vz-brand-carousel"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('vz-brand-carousel')) {
    customElements.define('vz-brand-carousel', class extends HTMLElement {
      connectedCallback() {
        if (this.dataset.ready === 'true') return;
        this.dataset.ready = 'true';
        this.initializeFrame = window.requestAnimationFrame(() => this.initialize());
      }

      initialize() {
        this.track = this.querySelector('[data-vz-track]');
        this.cards = Array.from(this.querySelectorAll('.vz-brand-card'));
        this.dots = Array.from(this.querySelectorAll('[data-vz-dot]'));
        this.scrollFrame = null;
        this.addEventListener('click', this.handleClick.bind(this));
        if (this.track && this.dots.length) {
          this.track.addEventListener('scroll', () => {
            if (this.scrollFrame) return;
            this.scrollFrame = window.requestAnimationFrame(() => {
              this.scrollFrame = null;
              this.updatePagination();
            });
          }, { passive: true });
          this.updatePagination();
        }
      }

      updatePagination() {
        if (!this.track || !this.dots.length) return;
        const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
        const progress = maxScroll ? this.track.scrollLeft / maxScroll : 0;
        const activeIndex = Math.min(
          this.dots.length - 1,
          Math.max(0, Math.round(progress * (this.dots.length - 1)))
        );

        this.dots.forEach((dot, index) => {
          const isActive = index === activeIndex;
          dot.classList.toggle('is-active', isActive);
          if (isActive) dot.setAttribute('aria-current', 'true');
          else dot.removeAttribute('aria-current');
        });
      }

      getCartCount() {
        const counts = Array.from(document.querySelectorAll('[data-vz-cart-count], [data-cart-count], .cart-count-bubble span, [ref="cartBubbleText"]'))
          .map((node) => Number.parseInt(node.textContent, 10))
          .filter(Number.isFinite);
        return counts.length ? Math.max(...counts) : 0;
      }

      setCartCount(count) {
        document.querySelectorAll('[data-vz-cart-count], [data-cart-count], .cart-count-bubble span, [ref="cartBubbleText"]').forEach((node) => {
          node.textContent = count;
          if (node.matches('[data-vz-cart-count]')) node.classList.toggle('is-empty', count === 0);
        });
      }

      animateToCart(addButton) {
        const dialog = addButton.closest('dialog');
        const cartButton = dialog && dialog.querySelector('.vz-quick__cart');
        if (!cartButton) return;

        cartButton.classList.remove('is-bumped');
        if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
          cartButton.classList.add('is-bumped');
          window.setTimeout(() => cartButton.classList.remove('is-bumped'), 360);
          return;
        }

        const start = addButton.getBoundingClientRect();
        const target = cartButton.getBoundingClientRect();
        const startX = start.left + (start.width / 2) - 5;
        const startY = start.top + (start.height / 2) - 5;
        const targetX = target.left + (target.width / 2) - 5;
        const targetY = target.top + (target.height / 2) - 5;
        const dot = document.createElement('span');
        dot.className = 'vz-quick__fly-dot';
        dot.setAttribute('aria-hidden', 'true');
        dot.style.left = startX + 'px';
        dot.style.top = startY + 'px';
        dot.style.setProperty('--vz-fly-x', (targetX - startX) + 'px');
        dot.style.setProperty('--vz-fly-y', (targetY - startY) + 'px');
        document.body.appendChild(dot);

        window.setTimeout(() => {
          cartButton.classList.add('is-bumped');
          window.setTimeout(() => cartButton.classList.remove('is-bumped'), 340);
        }, 390);
        window.setTimeout(() => dot.remove(), 560);
      }

      flashAddFeedback(addButton) {
        window.clearTimeout(addButton.vzFeedbackTimer);
        addButton.classList.remove('is-added');
        void addButton.offsetWidth;
        addButton.classList.add('is-added');
        addButton.vzFeedbackTimer = window.setTimeout(() => {
          addButton.classList.remove('is-added');
        }, 330);
      }

      syncCart(root) {
        window.clearTimeout(this.cartSyncTimer);
        this.cartSyncTimer = window.setTimeout(() => {
          fetch(root + 'cart.js', { headers: { 'Accept': 'application/json' } })
            .then((result) => result.json())
            .then((cart) => {
              this.setCartCount(cart.item_count);
              document.dispatchEvent(new CustomEvent('cart:update', {
                bubbles: true,
                detail: { source: 'vz-brand-carousel', item: this.latestAddedItem, cart: cart }
              }));
            })
            .catch(() => {});
        }, 80);
      }

      ensureQuickRows(dialog) {
        if (!dialog || dialog.dataset.vzHydrated === 'true') return;
        const productList = dialog.querySelector('[data-vz-products]');
        const dataNode = dialog.querySelector('[data-vz-quick-data]');
        if (!productList || !dataNode) return;

        let products = [];
        try {
          products = JSON.parse(dataNode.textContent || '[]');
        } catch (error) {
          return;
        }
        if (!Array.isArray(products)) return;

        const activeButton = dialog.querySelector('[data-vz-strength-option].is-active');
        const activeStrength = activeButton ? activeButton.dataset.vzStrengthOption : '';
        const counts = {};
        const fragment = document.createDocumentFragment();

        products.forEach((product) => {
          const strength = String(product.strength || '');
          if (strength) counts[strength] = (counts[strength] || 0) + 1;
          const row = document.createElement('div');
          row.className = 'vz-quick__row';
          row.dataset.vzStrength = strength;
          if (activeStrength) row.hidden = strength !== activeStrength;

          const thumb = document.createElement('a');
          thumb.className = 'vz-quick__thumb';
          thumb.href = product.url || '#';
          thumb.setAttribute('aria-label', (product.title || product.name || 'Produkt') + ' ansehen');
          if (product.image) {
            const image = document.createElement('img');
            image.className = 'vz-quick__image';
            image.src = product.image;
            image.alt = '';
            image.loading = 'lazy';
            image.decoding = 'async';
            thumb.appendChild(image);
          } else {
            const fallback = document.createElement('span');
            fallback.setAttribute('aria-hidden', 'true');
            fallback.textContent = String(product.name || product.title || '?').slice(0, 1).toUpperCase();
            thumb.appendChild(fallback);
          }

          const productLink = document.createElement('a');
          productLink.className = 'vz-quick__product-link';
          productLink.href = product.url || '#';
          productLink.title = product.title || product.name || '';
          const productName = document.createElement('strong');
          productName.textContent = product.name || product.title || 'Produkt';
          productLink.appendChild(productName);

          const price = document.createElement('span');
          price.className = 'vz-quick__price';
          price.textContent = product.price || '';

          const addButton = document.createElement('button');
          addButton.className = 'vz-quick__add';
          addButton.type = 'button';
          addButton.dataset.vzAdd = '';
          addButton.dataset.variant = String(product.variant || '');
          addButton.dataset.title = product.title || '';
          addButton.dataset.quickName = product.name || '';
          addButton.disabled = !product.available;
          addButton.setAttribute('aria-label', (product.title || product.name || 'Produkt') + (product.available ? ' in den Warenkorb legen' : ' ist ausverkauft'));
          const icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
          icon.setAttribute('viewBox', '0 0 24 24');
          icon.setAttribute('aria-hidden', 'true');
          const iconPath = document.createElementNS('http://www.w3.org/2000/svg', 'path');
          iconPath.setAttribute('d', product.available ? 'M12 5v14M5 12h14' : 'M7 7l10 10M17 7 7 17');
          icon.appendChild(iconPath);
          addButton.appendChild(icon);

          row.append(thumb, productLink, price, addButton);
          fragment.appendChild(row);
        });

        productList.appendChild(fragment);
        const countNode = dialog.querySelector('[data-vz-quick-count]');
        if (countNode) {
          Object.keys(counts).forEach((strength) => {
            countNode.dataset['count' + strength] = String(counts[strength]);
          });
          if (activeStrength && counts[activeStrength] !== undefined) {
            countNode.textContent = counts[activeStrength] + ' ' + (countNode.dataset.vzCountLabel || 'Geschmacksrichtungen');
          }
        }
        dialog.dataset.vzHydrated = 'true';
        dataNode.remove();
      }
      async handleClick(event) {
        const strengthButton = event.target.closest('[data-vz-strength-option]');
        if (strengthButton) {
          const dialog = strengthButton.closest('dialog');
          const strength = strengthButton.dataset.vzStrengthOption;
          if (!dialog || !strength) return;

          dialog.querySelectorAll('[data-vz-strength-option]').forEach((button) => {
            const isActive = button === strengthButton;
            button.classList.toggle('is-active', isActive);
            button.setAttribute('aria-pressed', String(isActive));
          });

          dialog.querySelectorAll('.vz-quick__row[data-vz-strength]').forEach((row) => {
            row.hidden = row.dataset.vzStrength !== strength;
          });

          const countNode = dialog.querySelector('[data-vz-quick-count]');
          const count = countNode && countNode.dataset['count' + strength];
          if (countNode && count) countNode.textContent = count + ' ' + (countNode.dataset.vzCountLabel || 'Geschmacksrichtungen');

          const productList = dialog.querySelector('.vz-quick__products');
          if (productList) productList.scrollTop = 0;
          return;
        }

        const dotButton = event.target.closest('[data-vz-dot]');
        if (dotButton && this.track) {
          const index = Number(dotButton.dataset.vzDot);
          const maxScroll = Math.max(0, this.track.scrollWidth - this.track.clientWidth);
          const lastIndex = Math.max(1, this.dots.length - 1);
          const left = maxScroll * (index / lastIndex);
          this.track.scrollTo({ left: left, behavior: 'smooth' });
          return;
        }

        const scrollButton = event.target.closest('[data-vz-scroll]');
        if (scrollButton) {
          const track = this.querySelector('[data-vz-track]');
          const direction = Number(scrollButton.dataset.vzScroll);
          track.scrollBy({ left: direction * Math.min(track.clientWidth * .84, 520), behavior: 'smooth' });
          return;
        }

        const openButton = event.target.closest('[data-vz-open]');
        if (openButton) {
          const dialog = document.getElementById(openButton.dataset.vzOpen);
          if (dialog && !dialog.open) {
            this.ensureQuickRows(dialog);
            dialog.showModal();
          }
          return;
        }

        const closeButton = event.target.closest('[data-vz-close]');
        if (closeButton) {
          closeButton.closest('dialog').close();
          return;
        }

        const addButton = event.target.closest('[data-vz-add]');
        if (!addButton) return;

        const root = window.Shopify && window.Shopify.routes ? window.Shopify.routes.root : '/';
        this.pendingAdds = (this.pendingAdds || 0) + 1;
        this.setCartCount(this.getCartCount() + 1);
        this.animateToCart(addButton);
        this.flashAddFeedback(addButton);

        try {
          const response = await fetch(root + 'cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
            body: JSON.stringify({ items: [{ id: Number(addButton.dataset.variant), quantity: 1 }] })
          });
          if (!response.ok) throw new Error('cart');

          this.latestAddedItem = await response.json();
        } catch (error) {
          this.setCartCount(Math.max(0, this.getCartCount() - 1));
        } finally {
          this.pendingAdds = Math.max(0, this.pendingAdds - 1);
          if (this.pendingAdds === 0) this.syncCart(root);
        }
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
